export default {
    header: {
        megatrend: 'Mega-trend',
        macrotrends: 'Macro-trends',
        publishingYear: 'Published',
        universes: 'Universes',
        author: 'Author',
        active: 'Active?',
        copy: 'Copy'
    },
    confirm: {
        title: 'Please note',
        notice: 'Deactivating a mega-trend also deactivates all associated macro-trends.',
        confirm: 'Deactivate Mega-trend'
    },
    filterOptions: {
        inactive: 'inactive',
        active: 'active'
    },
    search: 'Search'
}
